import { z } from "zod";
import { idSchema, isoDateTimeSchema, paginatedResponseSchema } from "./shared";

export const adminUserRoleSchema = z.enum(["admin", "member"]);
export const adminUserStatusSchema = z.enum(["active", "disabled"]);

export const adminUserSchema = z.object({
  id: idSchema,
  workspaceId: idSchema,
  email: z.string().email(),
  name: z.string().min(1),
  role: adminUserRoleSchema,
  status: adminUserStatusSchema,
  googleSubject: z.string().min(1).nullable(),
  lastLoginAt: isoDateTimeSchema.nullable(),
  avatarUrl: z.string().url().nullable(),
  createdAt: isoDateTimeSchema,
  updatedAt: isoDateTimeSchema,
});

export const createAdminUserRequestSchema = z.object({
  email: z.string().trim().email(),
  name: z.string().trim().min(1),
  role: adminUserRoleSchema.default("member"),
  status: adminUserStatusSchema.default("active"),
  googleSubject: z.string().trim().min(1).nullable().optional(),
  avatarUrl: z.string().trim().url().nullable().optional(),
});

export const preProvisionAdminUserRequestSchema = z.object({
  email: z.string().trim().email(),
  name: z.string().trim().min(1).optional(),
  role: adminUserRoleSchema.default("member"),
  googleSubject: z.string().trim().min(1).nullable().optional(),
  avatarUrl: z.string().trim().url().nullable().optional(),
});

export const updateAdminUserRequestSchema = z
  .object({
    email: z.string().trim().email().optional(),
    name: z.string().trim().min(1).optional(),
    role: adminUserRoleSchema.optional(),
    status: adminUserStatusSchema.optional(),
    googleSubject: z.string().trim().min(1).nullable().optional(),
    lastLoginAt: isoDateTimeSchema.nullable().optional(),
    avatarUrl: z.string().trim().url().nullable().optional(),
  })
  .refine((value) => Object.keys(value).length > 0, "At least one user field must be provided");

export const adminUserListResponseSchema = paginatedResponseSchema(adminUserSchema);

export type AdminUserDto = z.infer<typeof adminUserSchema>;
export type CreateAdminUserRequest = z.infer<typeof createAdminUserRequestSchema>;
export type PreProvisionAdminUserRequest = z.infer<typeof preProvisionAdminUserRequestSchema>;
export type UpdateAdminUserRequest = z.infer<typeof updateAdminUserRequestSchema>;
